import Loading from "components/widgets/Loading"
import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"
import CountryOrSiteScoreLayoutOrganism from "views/organisms/canvases/charts/ScorePerLevel/CountryOrSiteScoreLayoutOrganism"
import BrandScoreLayoutOrganism from "views/organisms/canvases/charts/ScorePerLevel/BrandScoreLayoutOrganism"
import RegionScoreLayoutOrganism from "views/organisms/canvases/charts/ScorePerLevel/RegionScoreLayoutOrganism"
import CompanyScoreLayoutOrganism from "views/organisms/canvases/charts/ScorePerLevel/CompanyScoreLayoutOrganism"
import {
  NODE_TYPE_BRAND,
  NODE_TYPE_COMPANY,
  NODE_TYPE_COUNTRY,
  NODE_TYPE_COUNTRY_TEAM,
  NODE_TYPE_PARTNER,
  NODE_TYPE_PHASE,
  NODE_TYPE_PROGRAM,
  NODE_TYPE_PROJECT,
  NODE_TYPE_REGION,
  NODE_TYPE_SERVICE,
  NODE_TYPE_SERVICE_COMPONENT,
  NODE_TYPE_SITE,
} from "utils/constants/organization/nodeTypes"
import { useAppContext } from "components/AppContext"
import Objective13PartialScoreLayoutOrganism from "views/organisms/canvases/charts/ScorePerLevel/Objective13PartialScoreOrganism"
import MetabaseChartMolecule from "views/molecules/canvases/charts/analytics/MetabaseChartMolecule"
import { useParams } from "react-router-dom"
import classNames from "classnames"
import "stylesheets/Score.scss"

const Objective13ScoreOrganism = ({ score }) => {
  const firstLoad = useRef(true)
  const { pillarId: urlPillarId } = useParams()

  const {
    currentNode,
    isCurrentNodeLoading,
    isScoreLoading,
    isEnvScoreLoading,
    isEnvCollectLoading,
    score: globalScore
  } = useAppContext()

  useEffect(() => {
    firstLoad.current = false
  })

  const trendBadges = globalScore?.trend_badges

  const displayChartsByNodeType = () => {
    if (score.sdg13_partial_collect_charts) {
      return (
        <Objective13PartialScoreLayoutOrganism 
          score={score} 
          trendBadges={trendBadges}
        />
      )
    }

    switch (currentNode?.type) {
      case NODE_TYPE_COMPANY:
      case NODE_TYPE_PARTNER:
      case NODE_TYPE_PROGRAM:
      case NODE_TYPE_SERVICE:
      case NODE_TYPE_PROJECT:
        return (
          <CompanyScoreLayoutOrganism 
            score={score} 
            trendBadges={trendBadges}
          />
        )

      case NODE_TYPE_BRAND:
        return (
          <BrandScoreLayoutOrganism 
            score={score} 
            trendBadges={trendBadges}
          />
        )

      case NODE_TYPE_REGION:
      case NODE_TYPE_SERVICE_COMPONENT:
      case NODE_TYPE_PHASE:
        return (
          <RegionScoreLayoutOrganism 
            score={score} 
            trendBadges={trendBadges}
          />
        )

      // Todo: remove hard coded orga node
      case NODE_TYPE_COUNTRY:
      case NODE_TYPE_COUNTRY_TEAM:
      case NODE_TYPE_SITE:
        if (
          (currentNode?.id === 2912 && currentNode?.name === "FR") ||
          (currentNode?.id === 2911 && currentNode?.name === "eSNCF Solutions")
        ) {
          return (
            <div className="Verdikt-Score">
              <div className={classNames(urlPillarId, "page-frame")}>
                <div className="page">
                  <MetabaseChartMolecule verdikt_alias="dashboard_score_multi_app" />
                </div>
              </div>
            </div>
          )
        }
        return (
          <CountryOrSiteScoreLayoutOrganism
            score={score}
            isConsolidated={currentNode?.has_children}
            trendBadges={trendBadges}
          />
        )
      default:
        return null
    }
  }

  if (
    isCurrentNodeLoading ||
    isScoreLoading ||
    isEnvScoreLoading ||
    isEnvCollectLoading
  )
    return <Loading />
  else return displayChartsByNodeType()
}

Objective13ScoreOrganism.propTypes = {
  score: PropTypes.object.isRequired,
}

export default Objective13ScoreOrganism